/**
 *
 * IMPORTANT:
 * This file is used both in vue2 and vue3
 * Dont use the vue syntax and the store concept in this file.
 * For any clarifications please contact Leela
 *
 */

import axios from 'axios';
import {
  RECENT_VDP_VIN_KEY,
  RECENT_VDP_ACCOUNTID_KEY,
  INTERESTED_PAYMENT_TYPE,
  RECENT_VDP_PAYMENT_INFO,
  CASH,
} from '../../constants/constants';
import { toyotaTdapLinks } from '../../services/Dealer/ToyotaService';
import { isVDVEnabledOnDynamicBanners } from '../shared/VdvPanel/service/VdvService';
import { isToyotaTheme } from '../../constants/ThemeConstants';

export default {
  data() {
    return {
      bannersdata: [],
      camBannersData: {
        requiredBanners: [],
        optionalBanners: [],
      },
      noBannerWithBgImage: true,
      bannerQuality: window.isSrp ? 95 : 85,
    };
  },
  props: {
    bannerOptions: {
      required: false,
      default: {},
      type: Object,
    },
    automatedBannerOptions: {
      required: false,
      default() {
        return {};
      },
      type: Object,
    },
  },
  computed: {},
  mounted() {
    this.isVDVEnable();
  },
  methods: {
    async getCamRotationalBanner(isOptional) {
      let url = `${window.ApiBaseUrl}/OEMProgramsCommon/DealerManifestURLs?dealerCode=04072&includeOptionalBanners=${isOptional}`;
      try {
        const response = await axios.get(url);
        if (response?.data?.bannerUrls?.length) {
          let requiredCambanners = [];
          let optionalCambanners = [];
          if (isOptional) {
            requiredCambanners = response.data.bannerUrls.filter((t) => t.isRequired);
            optionalCambanners = response.data.bannerUrls.filter((t) => !t.isRequired);
          } else {
            requiredCambanners = response.data.bannerUrls;
          }
          this.camBannersData.requiredBanners = requiredCambanners.length
            ? this.getCamBannerImageLogic(requiredCambanners)
            : [];
          this.camBannersData.optionalBanners = optionalCambanners.length
            ? this.getCamBannerImageLogic(optionalCambanners)
            : [];
        }
        return Promise.resolve(this.camBannersData);
      } catch {
        return Promise.resolve({ requiredBanners: [], optionalBanners: [] });
      }
    },
    getImageSourceUrl(banner) {
      if (banner?.rotationalBannerType?.toLowerCase() === 'tdap') {
        return banner.imageUrl;
      }
      return banner.imageUrl + `&type=webp&quality=${this.bannerQuality}`;
    },
    getImageSourceUrlMobile(banner) {
      if (banner?.rotationalBannerType?.toLowerCase() === 'tdap') {
        return banner.mobileImageUrl;
      }
      return banner.mobileImageUrl + '&type=webp&quality=100';
    },
    getWidthHeightLogic(bannerUrls) {
      const size = window.ismobile
        ? this.bannerOptions?.mobileBannerImageSize || ''
        : this.bannerOptions?.desktopBannerImageSize || '';
      let width = window.ismobile ? 600 : 1920;
      let height = window.ismobile ? 400 : 768;
      if (size?.toLowerCase() === 'medium') {
        height = window.ismobile ? 400 : 500;
      }
      if (size?.toLowerCase() === 'large') {
        height = window.ismobile ? 800 : 768;
      }
      if (size?.toLowerCase() === 'extra-large') {
        height = window.ismobile ? 800 : 1080;
      }

      return {
        banners: bannerUrls.filter((t) => t.width === width && t.height === height),
        width,
        height,
      };
    },
    getCamBannerImageLogic(bannerUrls) {
      let bannerData = this.getWidthHeightLogic(bannerUrls);
      let filteredBanners = bannerData.banners;

      const uniqueBanners = {};
      filteredBanners.forEach((banner) => {
        if (
          !uniqueBanners[banner.name] ||
          (uniqueBanners[banner.name] && banner.height === bannerData.height)
        ) {
          uniqueBanners[banner.name] = banner;
        }
      });

      return Object.values(uniqueBanners).map((t) => {
        let link = toyotaTdapLinks(t);
        return {
          ...t,
          imageLink: link,
          imageUrl: t.fullBannerUrl,
          mobileImageUrl: t.fullBannerUrl,
          rotationalBannerType: 'tdap',
          bannerId: Math.floor(Math.random() * (999999 - 10 + 1)) + 10,
          altText: t.imageAltText,
        };
      });
    },
    frameBannerAPIUrl(url) {
      let recentVin = localStorage.getItem(RECENT_VDP_VIN_KEY);
      let recentVdpAccountId = localStorage.getItem(RECENT_VDP_ACCOUNTID_KEY);
      let interestedPaymentType = localStorage.getItem(INTERESTED_PAYMENT_TYPE);
      const recentVdpPaymentInfo = JSON.parse(
        localStorage.getItem(RECENT_VDP_PAYMENT_INFO) || '{}'
      );

      if (recentVin) {
        url = `${url}&interestedVehicleVin=${recentVin}`;
      }
      if (recentVdpAccountId) {
        url = `${url}&vdpAccountId=${recentVdpAccountId}`;
      }
      if (interestedPaymentType) {
        url = `${url}&interestedPaymentType=${interestedPaymentType}`;
      }

      if (recentVdpPaymentInfo.term && interestedPaymentType?.toLowerCase() !== CASH) {
        url = `${url}&term=${recentVdpPaymentInfo.term}`;
      }

      if (window.location.href.toLowerCase().indexOf('fetchdatafrom') > -1) {
        url = `${url}&fetchdatafrom=db`;
      }
      return url;
    },
    getVdpUrl(bannerOffer) {
      let vdpUrl = bannerOffer.vdpUrl;
      if (bannerOffer?.vin && bannerOffer?.vdpUrl) {
        if (bannerOffer.offerType) {
          vdpUrl = !vdpUrl.includes('?')
            ? `${vdpUrl}?type=${bannerOffer.offerType}`
            : `${vdpUrl}&type=${bannerOffer.offerType}`;
        }
        if (bannerOffer.term) {
          vdpUrl = !vdpUrl.includes('?')
            ? `${vdpUrl}?term=${bannerOffer.term}`
            : `${vdpUrl}&term=${bannerOffer.term}`;
        }
      }
      return vdpUrl;
    },
    getVehicleOfferVdpUrl(banner) {
      let bannerOffer = banner.bannersPaymentHomenetVehicle;

      let paymentType =
        banner.rotationalBannerType?.toLowerCase() === 'vehicleoffer' ||
        banner.rotationalBannerType?.toLowerCase() === 'vehicleapr'
          ? bannerOffer.paymentType
          : bannerOffer.paymentTypeToDisplay;

      let vdpUrl = bannerOffer?.vdpUrl;

      if (bannerOffer?.vin && bannerOffer?.vdpUrl) {
        if (paymentType) {
          vdpUrl = !vdpUrl.includes('?')
            ? `${vdpUrl}?type=${paymentType}`
            : `${vdpUrl}&type=${paymentType}`;
        }
        if (bannerOffer.term) {
          vdpUrl = !vdpUrl.includes('?')
            ? `${vdpUrl}?term=${bannerOffer.term}`
            : `${vdpUrl}&term=${bannerOffer.term}`;
        }
      }
      return vdpUrl;
    },
    findBannerType(banner) {
      return banner?.rotationalBannerType?.toLowerCase() === 'image';
    },
    setClassForAutoBanner(banner) {
      let stylesList = {};
      if (
        this.isAutomatedBanner(banner) &&
        banner?.bannerBackgroundType.toLowerCase() === 'solid-color'
      ) {
        stylesList = {
          backgroundColor: banner.bannerBackgroundColor || '#fff',
          height: '100%',
        };
      } else if (
        this.isAutomatedBanner(banner) &&
        banner?.bannerBackgroundType.toLowerCase() === 'gradient-color'
      ) {
        stylesList = {
          backgroundImage: `linear-gradient(to ${banner.gradientDirection}, ${banner.gradientColor1}, ${banner.gradientColor2})`,
          height: '100%',
        };
      } else {
        //No action needed for other cases
      }
      return stylesList;
    },
    getBannerBgType(banner) {
      return !(
        this.isAutomatedBanner(banner) &&
        (banner?.bannerBackgroundType.toLowerCase() === 'solid-color' ||
          banner?.bannerBackgroundType.toLowerCase() === 'gradient-color')
      );
    },
    isAutomatedBanner(banner) {
      return (
        banner?.rotationalBannerType.toLowerCase() === 'specialoffer' ||
        banner?.rotationalBannerType.toLowerCase() === 'vehicleoffer' ||
        banner?.rotationalBannerType.toLowerCase() === 'vehicleofinterest' ||
        banner?.rotationalBannerType.toLowerCase() === 'vehicleapr'
      );
    },
    getUrl(banner) {
      let url = banner.url;
      if (
        banner.rotationalBannerType?.toLowerCase() === 'specialoffer' &&
        !banner.url &&
        banner.offer
      ) {
        url = this.getVdpUrl(banner.offer);
      } else if (
        (banner.rotationalBannerType?.toLowerCase() === 'vehicleoffer' ||
          banner.rotationalBannerType?.toLowerCase() === 'vehicleapr' ||
          banner.rotationalBannerType?.toLowerCase() === 'vehicleofinterest') &&
        !banner.url &&
        banner.bannersPaymentHomenetVehicle
      ) {
        url = this.getVehicleOfferVdpUrl(banner);
      } else {
        //No action needed for other cases
      }
      if (url) {
        if (url.includes('http:') || url.includes('https:')) {
          return url;
        } else {
          return window.baseUrl + url;
        }
      } else if (banner.rotationalBannerType === 'tdap' && banner.imageLink) {
        url = banner.imageLink;
        if (url.includes('http:') || url.includes('https:')) {
          return url;
        } else {
          return window.baseUrl + url;
        }
      } else {
        //No action needed for other cases
      }

      return '#';
    },
    filterOfferIsValid(bannerResponse) {
      //map section level banner size selection value into each banner mobile & desktop keys
      let bannersAfterMapping = this.mapBannersWithBannerOptions(bannerResponse);

      let filteredBanneResponse = bannersAfterMapping.filter((banner) => {
        if (banner.rotationalBannerType?.toLowerCase() === 'specialoffer') {
          return banner.offer;
        } else if (banner.rotationalBannerType?.toLowerCase() === 'vehicleoffer') {
          return banner.bannersPaymentHomenetVehicle;
        } else if (banner.rotationalBannerType?.toLowerCase() === 'vehicleofinterest') {
          return banner.bannersPaymentHomenetVehicle;
        } else if (banner.rotationalBannerType?.toLowerCase() === 'vehicleapr') {
          return banner.bannersPaymentHomenetVehicle;
        } else {
          //No action needed for other cases
        }
        return banner;
      });
      //set height for dynamic banners with solid or gradient backgrounds
      this.setHeightClassToBannerParent(filteredBanneResponse);
      return filteredBanneResponse;
    },

    filterEmptyBanner(banners, isMobile) {
      const toyota = isToyotaTheme();
      // Filter out the banners with out images
      return banners.filter((banner) => {
        if (
          ['specialoffer', 'vehicleoffer', 'vehicleofinterest', 'vehicleapr'].includes(
            banner.rotationalBannerType?.toLowerCase()
          ) &&
          banner.BannerBackgroundType !== 'image'
        ) {
          return true;
        }

        if (
          toyota &&
          ['requiredtdapbanners', 'optionaltdapbanners'].includes(
            banner.rotationalBannerType?.toLowerCase()
          )
        ) {
          return true;
        }

        return isMobile ? banner.mobileImageUrl : banner.imageUrl;
      });
    },
    mapBannersWithBannerOptions(bannerResponse) {
      let bannerSizes = {
        imageSizeType: this.automatedBannerOptions?.desktopBannerImageSize,
        mobileImageSizeType: this.automatedBannerOptions?.mobileBannerImageSize,
      };
      let bannerDataAfterMapping = bannerResponse.map((banner) => {
        return { ...banner, ...bannerSizes };
      });
      return bannerDataAfterMapping;
    },
    setHeightClassToBannerParent(banners) {
      banners.forEach((banner) => {
        if (
          banner.rotationalBannerType?.toLowerCase() === 'image' ||
          banner.bannerBackgroundType?.toLowerCase() === 'image'
        ) {
          this.noBannerWithBgImage = false;
          return false;
        }
      });
    },
    conquestProfileLogic(banners) {
      let isAnyVOIBannersAvailable = banners.find(
        (banner) => banner.rotationalBannerType?.toLowerCase() === 'vehicleofinterest'
      );
      if (isAnyVOIBannersAvailable?.bannersPaymentHomenetVehicle?.vin) {
        const style = document.createElement('style');
        style.innerHTML = `
       .vehicle-of-interest-${isAnyVOIBannersAvailable.bannersPaymentHomenetVehicle.vin.toLowerCase()} {
         display:none
       }
     `;
        document.head.appendChild(style);
      }
    },
    async isVDVEnable() {
      window.enableVdvPanel = isVDVEnabledOnDynamicBanners();
    },
  },
};
